import axios from "shared/tools/axiosMultisite";

export default {
    state: () => ({
        language: '',
        currency: '',
        variants: [],
		colors: [],
        selectedVariant: null,
        productCode: '',
        activeForHcpOnly: false,
        currentFormattedPrice: '',
        currentFormattedPricePerItem: '',
        currentPrice: 0,
		currentUnitPrice: 0,
		selectedVariantCode: null,
		quantity: 0,
        selectedVariantIsSample: false,
		selectedVariantIsCut: false,
		signupSigninSearchParameters: {},
		isProductCardOnCampaignPage: false,
    }),
    getters: {
        getVariants: (state) => {
            return state.variants;
        },
        getColors: (state) => {
            return state.colors;
        },
        getSelectedVariant: (state) => {
            return state.selectedVariant;
        },
        getActiveForHcpOnly: (state) => {
            return state.activeForHcpOnly;
        },
        getCurrentFormattedPrice: (state) => {
            return state.currentFormattedPrice;
        },
        getCurrentFormattedPricePerItem: (state) => {
            return state.currentFormattedPricePerItem;
        },
        getCurrentPrice: (state) => {
            return state.currentPrice;
        },
		getCurrentUnitPrice: (state) => {
            return state.currentUnitPrice;
        },
		getSelectedVariantCode: (state) => {
			return state.selectedVariantCode;
		},
		getQuantity: (state) => {
			return state.quantity;
		},
        getSelectedVariantIsSample: (state) => {
            return state.selectedVariantIsSample;
        },
		getSelectedVariantIsCut: (state) => {
			return state.selectedVariantIsCut;
		},
        getSignupSigninSearchParameters: (state) => {
            return state.signupSigninSearchParameters;
		},
		getIsProductCardOnCampaignPage: (state) => {
			return state.isProductCardOnCampaignPage;
		},
    },
    mutations: {
        setProductCode: (state, productCode) => {
            state.productCode = productCode;
        },
        setLanguage: (state, language) => {
            state.language = language;
        },
        setCurrency: (state, currency) => {
            state.currency = currency;
        },
        setVariants: (state, variants) => {
            state.variants = variants;
        },
		setColors: (state, colors) => {
            state.colors = colors;
        },
        setSelectedVariant: (state, selectedVariant) => {
            state.selectedVariant = selectedVariant;
        },
        setActiveForHcpOnly: (state, value) => {
            state.activeForHcpOnly = value;
        },
        setCurrentFormattedPrice: (state, price) => {
            state.currentFormattedPrice = price;
        },
        setCurrentFormattedPricePerItem: (state, price) => {
            state.currentFormattedPricePerItem = price;
        },
        setCurrentPrice: (state, price) => {
            state.currentPrice = price;
        },
		setCurrentUnitPrice: (state, price) => {
			state.currentUnitPrice = price;
		},
		setSelectedVariantInfo: (state, data) => {
			state.selectedVariantCode = data.selectedVariantCode;
			state.quantity = data.quantity;
            state.selectedVariantIsSample = data.isSample;
			state.selectedVariantIsCut = data.isCut;
		},
		setSelectedVariantIsCut: (state, data) => {
			state.selectedVariantIsCut = data;
		},
        setSignupSigninSearchParameters: (state, data) => {
            state.signupSigninSearchParameters = data;
		},
		setIsProductCardOnCampaignPage: (state, value) => {
			state.isProductCardOnCampaignPage = value;
		},
    },
    actions: {
        fetchVariants: ({ commit, state }) => {
			if (!state.language || !state.productCode) {
                return;
            }

			const url = `/api/productdetailsservice/getvariantsforproduct?language=${state.language}&productCode=${state.productCode}`;

            return axios.get(url)
                .then((variantResult) => {
                    commit('setVariants', variantResult.data);
                })
        },
		addToBasket: ({ state, rootGetters }, params) => {
            if (!state.selectedVariant) {
                return;
            }
            let payload = {
				Code: state.selectedVariant.Item.Code,
                Quantity: params.quantity,
                MarketId:  rootGetters['getMarketId'],
                DefaultCurrency: state.currency,
                IsSample: !!params.isSample,
                Language: state.language,
                LineItemSource: params.lineItemSource,
                TrackingParameters: params.trackingParameters,
            };
			return axios.post('/api/global-basket/additem', payload)
			.then(response => response)
			.catch(error => error.response);
        },
        fetchPrice: ({ commit, state }, quantity) => {
            if (!state.selectedVariant) {
                commit('setCurrentFormattedPrice', '');
                return;
            }
            return axios.get(`/api/global-basket/price?code=${state.selectedVariant.Item.Code}&language=${state.language}&quantity=${quantity}`)
                .then((priceResult) => {
                    commit('setCurrentFormattedPrice', priceResult.data.formattedPrice);
                    commit('setCurrentFormattedPricePerItem', priceResult.data.formattedPricePerItem);
                    commit('setCurrentPrice', priceResult.data.price);
					commit('setCurrentUnitPrice', priceResult.data.unitPrice);

					return priceResult;
                })
				.catch(error => error.response);
        },
		fetchShippingRate: ({ state }, params) => {
			if (params.variants.length < 1) {
                return;
            }

			const code = params.variants[0].Item.Code;

			const payload = {
                code: code,
                quantity: params.quantity,
                issample: params.isSample,
                language: state.language
            };

			return axios.get(`/api/shipping/rate?${new URLSearchParams(payload).toString()}`)
			.then(response => response)
			.catch(error => error.response);
		}
    }
}
